import { render, staticRenderFns } from "./team-join.vue?vue&type=template&id=6d2db1aa&scoped=true"
import script from "./team-join.vue?vue&type=script&lang=js"
export * from "./team-join.vue?vue&type=script&lang=js"
import style0 from "./team-join.vue?vue&type=style&index=0&id=6d2db1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2db1aa",
  null
  
)

export default component.exports